export function ScanMedicationIcon() {
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M48.0729 51.9277H39.1813C38.6993 51.9277 38.3086 51.537 38.3086 51.0549C38.3086 50.5729 38.6993 50.1822 39.1813 50.1822H48.0729C49.236 50.1822 50.1822 49.236 50.1822 48.0729V39.1813C50.1822 38.6993 50.5729 38.3086 51.0549 38.3086C51.537 38.3086 51.9277 38.6993 51.9277 39.1813V48.0729C51.9277 50.1984 50.1984 51.9277 48.0729 51.9277Z"
        fill="black"
      />
      <path
        d="M51.0549 13.6191C50.5729 13.6191 50.1822 13.2284 50.1822 12.7464V3.85479C50.1822 2.69171 49.236 1.74545 48.0729 1.74545H39.1813C38.6993 1.74545 38.3086 1.35473 38.3086 0.872727C38.3086 0.39072 38.6993 0 39.1813 0H48.0729C50.1984 0 51.9277 1.72926 51.9277 3.85479V12.7464C51.9277 13.2284 51.537 13.6191 51.0549 13.6191Z"
        fill="black"
      />
      <path
        d="M0.872727 13.6191C0.39072 13.6191 0 13.2284 0 12.7464V3.85479C0 1.72926 1.72926 0 3.85479 0H12.7464C13.2284 0 13.6191 0.39072 13.6191 0.872727C13.6191 1.35473 13.2284 1.74545 12.7464 1.74545H3.85479C2.69171 1.74545 1.74545 2.69171 1.74545 3.85479V12.7464C1.74545 13.2284 1.35473 13.6191 0.872727 13.6191Z"
        fill="black"
      />
      <path
        d="M12.7464 51.9277H3.85479C1.72926 51.9277 0 50.1984 0 48.0729V39.1813C0 38.6993 0.39072 38.3086 0.872727 38.3086C1.35473 38.3086 1.74545 38.6993 1.74545 39.1813V48.0729C1.74545 49.236 2.69171 50.1822 3.85479 50.1822H12.7464C13.2284 50.1822 13.6191 50.5729 13.6191 51.0549C13.6191 51.537 13.2283 51.9277 12.7464 51.9277Z"
        fill="black"
      />
      <path
        d="M29.7956 19.2964H19.7956M33.1289 25.9631H19.7956M28.1289 32.6297H19.7956M13.1289 9.29639V42.6297L16.4622 40.9631L19.7956 42.6297L23.1289 40.9631L26.4622 42.6297L29.7956 40.9631L33.1289 42.6297L36.4622 40.9631L39.7956 42.6297V9.29639L36.4622 10.9631L33.1289 9.29639L29.7956 10.9631L26.4622 9.29639L23.1289 10.9631L19.7956 9.29639L16.4622 10.9631L13.1289 9.29639Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M49.7455 25.6577H2.18189C1.82041 25.6577 1.52734 25.3647 1.52734 25.0032C1.52734 24.6417 1.82041 24.3486 2.18189 24.3486H49.7455C50.107 24.3486 50.4001 24.6417 50.4001 25.0032C50.4001 25.3647 50.107 25.6577 49.7455 25.6577Z"
        fill="#EF4444"
      />
    </svg>
  )
}
